import React from 'react';
import { Button } from '@upgrade/react-components';
import { scrollToElement } from '../../../utils/useScrollToHash';

const TermsLink = ({ children = 'Terms Apply' }) => {
  const handleClick = () => {
    const element = document.getElementById('disclaimer');
    scrollToElement(element, 'smooth');
  };

  return (
    <Button emphasis="tertiary" onClick={handleClick} buttonProps={{ 'aria-label': 'Jump to the terms of service' }}>
      {children}
    </Button>
  );
};

export default TermsLink;
